import ProductQuery from './ProductQuery';
import BaseSearch from '../Search/Search';

export default class ProductSearch extends BaseSearch {
    // sort options: 'latest', 'price_desc', 'price_asc', and 'in_stock'
    constructor(
        tax = null,
        postPerPage = 16,
        page = 1,
        sort = null,
        featured = false,
        sale = false,
        includeOldIds = null,
        excludeOldIds = null,
        includeIds = null,
        excludeIds = null,
    ) {
        super(null);

        const header = JSON.stringify({
            index: 'pelcro_products',
        });

        let bulkQuery = header + '\n';

        const formattedTaxonomy = tax !== null ? tax.replace(/&/g, '&amp;') : null;

        bulkQuery +=
            JSON.stringify(
                new ProductQuery(
                    null,
                    formattedTaxonomy,
                    postPerPage,
                    page,
                    sort,
                    null,
                    featured,
                    sale,
                    includeOldIds,
                    excludeOldIds,
                    includeIds,
                    excludeIds,
                ),
            ) + '\n';

        this.query = bulkQuery;
    }
}
